/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Review_SubmitInputs */

const en_ticket_review_submit = /** @type {(inputs: Ticket_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit review`)
};

const ja_ticket_review_submit = /** @type {(inputs: Ticket_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`評価を送信`)
};

const fr_ticket_review_submit = /** @type {(inputs: Ticket_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer l'évaluation`)
};

const de_ticket_review_submit = /** @type {(inputs: Ticket_Review_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertung absenden`)
};

/**
* | output |
* | --- |
* | "Submit review" |
*
* @param {Ticket_Review_SubmitInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_review_submit = /** @type {((inputs?: Ticket_Review_SubmitInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Review_SubmitInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_review_submit(inputs)
	if (locale === "ja") return ja_ticket_review_submit(inputs)
	if (locale === "fr") return fr_ticket_review_submit(inputs)
	return de_ticket_review_submit(inputs)
});